import React, { useContext } from 'react'
import ReactGA from "react-ga4"

import './App.css'
import AppProvider, { AppContext } from './context/appContext'
import Form from './component/Form/Form'
import Error from './component/Error/Error'
import { register } from './actions/actions'

ReactGA.initialize("G-210XBM3YXM")

const LandingPage: React.FC = () => {
  const {
    dispatch,
    state: { registered, error, hasError, submitting }
  } = useContext(AppContext)

  const submit = (email: string) => {
    register(email, dispatch)
  }

  return (
    <>
      {/* Main Section */}
      <main className="main">
        {/* Decorative Illustration */}
        <div className="illustration-container" aria-hidden="true">
          <div className="gradient-blob" />
          <img src="./img/person-laptop.svg" alt="" className="illustration" />
        </div>

        {/* Content */}
        <div className="content">
          <h1 className="title">
            FindaProperty.<br />
            Coming Soon.
          </h1>

          <p className="tagline">
            We're building <strong>findaproperty.mu</strong>, a next-generation real estate portal designed to connect buyers and sellers with the best opportunities in Mauritius.
          </p>

          {/* Signup Section */}
          <div className="signup-section">
            <span className="signup-label">Get notified when we launch</span>

            {hasError && <Error error={error} />}

            {registered ? (
              <div className="alert alert-success">
                Thanks! We'll notify you when we launch.
              </div>
            ) : (
              <Form submit={submit} submitting={submitting} />
            )}
          </div>

          {/* Blog promo */}
          <p className="blog-promo">
            While we're building the platform, explore our{' '}
            <a href="https://www.findaproperty.mu/news" target="_blank" rel="noopener noreferrer">
              blog
            </a>
            {' '}for the latest property news and market insights in Mauritius.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-main">
          <div className="footer-logo-section">
            <div className="footer-logo">
              <img src="./img/logo.svg" alt="FindaProperty" />
            </div>
            <p className="footer-brand">REAL ESTATE PLATFORM</p>
          </div>

          <div className="footer-social-section">
            <p className="footer-social-label">Follow us:</p>
            <div className="footer-social">
              <a href="https://twitter.com/findapropertymu" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/Findapropertymu" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/Findapropertymu/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5"/>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

          <p className="footer-copyright">
            © FindaProperty Limited, {new Date().getFullYear()}
          </p>
        </div>
      </footer>
    </>
  )
}

const App: React.FC = () => (
  <AppProvider>
    <LandingPage />
  </AppProvider>
)

export default App
